import { createContext, Dispatch, SetStateAction } from 'react';

import { CallModalProps } from './CallModalProps';

export const CallModalContext = createContext<{
  callModal: CallModalProps;
  setCallModal: Dispatch<SetStateAction<CallModalProps>>;
}>(null);
